//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { PROMOTED_POSTS_METRICS_ROUTES } from 'app/promoted-posts-metrics/promoted-posts-metrics-constants/promoted-posts-metrics-constants';

export const TRAFFIC_BY_CHANNELS_VALUES = {
  LIKE2BUY: 'LIKE2BUY',
  PROMOTED_POSTS: 'PROMOTED_POSTS',
  STORIES: 'STORIES',
  SHOP_TAGS: 'SHOP_TAGS',
} as const;

export const TRAFFIC_BY_CHANNELS_VALUES_LABELS = {
  [TRAFFIC_BY_CHANNELS_VALUES.LIKE2BUY]: 'Like2Buy',
  [TRAFFIC_BY_CHANNELS_VALUES.PROMOTED_POSTS]: 'Promoted Posts',
  [TRAFFIC_BY_CHANNELS_VALUES.STORIES]: 'Story Links',
  [TRAFFIC_BY_CHANNELS_VALUES.SHOP_TAGS]: 'Shop Tags',
};

// We use undefined here so we can use ng-attr in the markup
// to switch between the use of the href and ui-sref attributes
export const TRAFFIC_BY_CHANNELS_VALUES_ROUTES = {
  [TRAFFIC_BY_CHANNELS_VALUES.LIKE2BUY]: {
    type: 'href',
    value: '/insights/like2buy',
  },
  [TRAFFIC_BY_CHANNELS_VALUES.PROMOTED_POSTS]: {
    type: 'sref',
    value: PROMOTED_POSTS_METRICS_ROUTES.METRICS,
  },
  [TRAFFIC_BY_CHANNELS_VALUES.STORIES]: {
    type: 'sref',
    value: 'instagramAccount.storyEngagement',
  },
  [TRAFFIC_BY_CHANNELS_VALUES.SHOP_TAGS]: {
    type: 'sref',
    value: 'instagramAccount.shopTagsMetrics',
  },
};

export const TRAFFIC_BY_CHANNELS_VALUES_TOOLTIPS = {
  [TRAFFIC_BY_CHANNELS_VALUES.LIKE2BUY]:
    'Traffic and Revenue generated by on-site visitors referred by your Like2Buy store.',
  [TRAFFIC_BY_CHANNELS_VALUES.PROMOTED_POSTS]:
    'Traffic and Revenue generated by on-site visitors referred by your Promoted Posts.',
  [TRAFFIC_BY_CHANNELS_VALUES.STORIES]:
    'Traffic and Revenue generated by on-site visitors referred by your links in your Instagram stories.',
  [TRAFFIC_BY_CHANNELS_VALUES.SHOP_TAGS]:
    'Traffic and Revenue generated by on-site visitors referred by Shop Tags in your posts.',
};

export const UMS_CHANNELS = {
  [TRAFFIC_BY_CHANNELS_VALUES.LIKE2BUY]: 'L2B',
  [TRAFFIC_BY_CHANNELS_VALUES.PROMOTED_POSTS]: 'IG_PROMOTED_POST',
  [TRAFFIC_BY_CHANNELS_VALUES.STORIES]: 'IG_STORY',
  [TRAFFIC_BY_CHANNELS_VALUES.SHOP_TAGS]: 'IG_SHOPPING',
};

export const UMS_FIELDS = {
  VISITS: 'ecomSessions',
  REVENUE: 'revenue',
  TRANSACTIONS: 'transactions',
};
